export default {
  name: 'ClarificationText'
};